interface RouteDefinition {
  route: string;
  regex: RegExp;
}

export const ROUTES = {
  ACCOUNT: {
    route: ':name/account',
    regex: new RegExp('^([^/]+)/account$'),
  },
  BILLING: {
    route: ':name/billing(?*query)',
    regex: new RegExp('^([^/]+)/billing(?:\\?(.*?))?$'),
  },
  BILLING_CARD: {
    route: ':name/billing/card',
    regex: new RegExp('^([^/]+)/billing/card$'),
  },
  BILLING_CARD_PRODUCT: {
    route: ':name/billing/card/:product',
    regex: new RegExp('^([^/]+)/billing/card/([^/]+)$'),
  },
  BLANK: {
    route: 'blank',
    regex: new RegExp('^blank$'),
  },
  BOARD: {
    route: 'b/:shortLink(/*path)',
    regex: new RegExp('^b/([^/]+)(?:/(.*?))?$'),
  },
  BOARD_OLD: {
    route: 'board/*path',
    regex: new RegExp('^board/(.*?)$'),
  },
  BOARD_REFERRAL: {
    route: 'b/:shortLink/:name/:referrerUsername/recommend',
    regex: new RegExp('^b/([^/]+)/([^/]+)/([^/]+)/recommend$'),
  },
  CARD: {
    route: 'c/:id(/*path)',
    regex: new RegExp('^c/([^/]+)(?:/(.*?))?$'),
  },
  CARD_OLD: {
    route: 'card/(:slug/):idBoard/:cardComponent',
    regex: new RegExp('^card/(?:([^/]+)/)?([^/]+)/([^/]+)$'),
  },
  CARD_AND_BOARD_OLD: {
    route: 'card/board/(:slug/):idBoard/:cardComponent',
    regex: new RegExp('^card/board/(?:([^/]+)/)?([^/]+)/([^/]+)$'),
  },
  CREATE_FIRST_BOARD: {
    route: 'create-first-board(?*querystring)',
    regex: new RegExp('^create-first-board(?:\\?(.*?))?$'),
  },
  CREATE_FIRST_TEAM: {
    route: 'create-first-team',
    regex: new RegExp('^create-first-team$'),
  },
  DOUBLE_SLASH: {
    route: '/*search',
    regex: new RegExp('^/(.*?)$'),
  },
  ENTERPRISE_ADMIN: {
    route: 'e/:name/admin',
    regex: new RegExp('^e/([^/]+)/admin$'),
  },
  ENTERPRISE_ADMIN_TAB: {
    route: 'e/:name/admin/*tab',
    regex: new RegExp('^e/([^/]+)/admin/(.*?)$'),
  },
  ERROR_PAGE: {
    route: '*splat',
    regex: new RegExp('^(.*?)$'),
  },
  GO: {
    route: 'go/*search',
    regex: new RegExp('^go/(.*?)$'),
  },
  INVITE_ACCEPT_BOARD: {
    route: 'invite/accept-board',
    regex: new RegExp('^invite/accept-board$'),
  },
  INVITE_ACCEPT_TEAM: {
    route: 'invite/accept-team',
    regex: new RegExp('^invite/accept-team$'),
  },
  MEMBER_ACTIVITY: {
    route: ':username/activity',
    regex: new RegExp('^([^/]+)/activity$'),
  },
  MEMBER_ALL_BOARDS: {
    route: ':username/boards',
    regex: new RegExp('^([^/]+)/boards$'),
  },
  MEMBER_CARDS: {
    route: ':username/cards',
    regex: new RegExp('^([^/]+)/cards$'),
  },
  MEMBER_CARDS_FOR_ORG: {
    route: ':username/cards/:orgname',
    regex: new RegExp('^([^/]+)/cards/([^/]+)$'),
  },
  MEMBER_HOME: {
    route: '',
    regex: new RegExp('^$'),
  },
  MEMBER_HOME_BOARDS: {
    route: ':orgname/home',
    regex: new RegExp('^([^/]+)/home$'),
  },
  MEMBER_TASKS: {
    route: ':username/tasks',
    regex: new RegExp('^([^/]+)/tasks$'),
  },
  ORGANIZATION_BY_ID: {
    route: 'org/:id',
    regex: new RegExp('^org/([^/]+)$'),
  },
  ORGANIZATION_EXPORT: {
    route: ':name/export',
    regex: new RegExp('^([^/]+)/export$'),
  },
  ORGANIZATION_FREE_TRIAL: {
    route: ':name/free-trial',
    regex: new RegExp('^([^/]+)/free-trial$'),
  },
  ORGANIZATION_GUESTS: {
    route: ':name/members/guests',
    regex: new RegExp('^([^/]+)/members/guests$'),
  },
  ORGANIZATION_MEMBER_CARDS: {
    route: ':name/:username/cards',
    regex: new RegExp('^([^/]+)/([^/]+)/cards$'),
  },
  ORGANIZATION_MEMBERS: {
    route: ':name/members',
    regex: new RegExp('^([^/]+)/members$'),
  },
  ORGANIZATION_POWERUPS: {
    route: ':name/power-ups',
    regex: new RegExp('^([^/]+)/power-ups$'),
  },
  ORGANIZATION_TABLES: {
    route: ':name/tables',
    regex: new RegExp('^([^/]+)/tables$'),
  },
  POWER_UP_ADMIN: {
    route: 'power-ups/admin(/:section)(/)',
    regex: new RegExp('^power-ups/admin(?:/([^/]+))?(?:/)?$'),
  },
  POWER_UP_EDIT: {
    route: 'power-ups/:idPlugin/edit(/:subsection)(/)',
    regex: new RegExp('^power-ups/([^/]+)/edit(?:/([^/]+))?(?:/)?$'),
  },
  POWER_UP_PUBLIC_DIRECTORY: {
    route: 'power-ups(/:section)(/:subsection)(/)',
    regex: new RegExp('^power-ups(?:/([^/]+))?(?:/([^/]+))?(?:/)?$'),
  },
  PROFILE: {
    route: ':name/profile',
    regex: new RegExp('^([^/]+)/profile$'),
  },
  SEARCH: {
    route: 'search(?*query)',
    regex: new RegExp('^search(?:\\?(.*?))?$'),
  },
  SELECT_ORG_TO_UPGRADE: {
    route: 'select-org-to-upgrade',
    regex: new RegExp('^select-org-to-upgrade$'),
  },
  SELECT_TEAM_TO_UPGRADE: {
    route: 'select-team-to-upgrade',
    regex: new RegExp('^select-team-to-upgrade$'),
  },
  SHORTCUTS: {
    route: 'shortcuts',
    regex: new RegExp('^shortcuts$'),
  },
  SHORTCUTS_OVERLAY: {
    route: 'shortcuts/overlay',
    regex: new RegExp('^shortcuts/overlay$'),
  },
  TEAM_GETTING_STARTED: {
    route: ':orgname/getting-started',
    regex: new RegExp('^([^/]+)/getting-started$'),
  },
  TEAM_HIGHLIGHTS: {
    route: ':orgname/highlights',
    regex: new RegExp('^([^/]+)/highlights$'),
  },
  TEAM_REPORTS: {
    route: ':orgname/reports',
    regex: new RegExp('^([^/]+)/reports$'),
  },
  TEMPLATES_SUBMIT: {
    route: 'templates/submit',
    regex: new RegExp('^templates/submit$'),
  },
  TEMPLATES: {
    route: 'templates(/:category)(/:templateSlug)(/)',
    regex: new RegExp('^templates(?:/([^/]+))?(?:/([^/]+))?(?:/)?$'),
  },
  TEMPLATES_RECOMMEND: {
    route:
      'templates(/:category)(/:templateSlug)(/:referrerUsername)/recommend(/)',
    regex: new RegExp(
      '^templates(?:/([^/]+))?(?:/([^/]+))?(?:/([^/]+))?/recommend(?:/)?$',
    ),
  },
  TO: {
    route: 'to/*search',
    regex: new RegExp('^to/(.*?)$'),
  },
  USER_OR_ORG: {
    route: ':name(/)',
    regex: new RegExp('^([^/]+)(?:/)?$'),
  },
  WELCOME: {
    route: 'welcome',
    regex: new RegExp('^welcome$'),
  },
};

/**
 * This represents the order in which the paths are matched by the router
 */
export const ORDERED_ROUTE_LIST: RouteDefinition[] = [
  /**
   * Quick Boards
   */
  ROUTES.GO,
  ROUTES.TO,
  ROUTES.DOUBLE_SLASH,
  /**
   * Power Ups
   */
  ROUTES.POWER_UP_ADMIN,
  ROUTES.POWER_UP_EDIT,
  ROUTES.POWER_UP_PUBLIC_DIRECTORY,
  /**
   * Other
   */
  ROUTES.CREATE_FIRST_TEAM,
  ROUTES.SHORTCUTS,
  ROUTES.SHORTCUTS_OVERLAY,
  ROUTES.BLANK,
  ROUTES.SELECT_ORG_TO_UPGRADE,
  ROUTES.SELECT_TEAM_TO_UPGRADE,
  ROUTES.SEARCH,
  ROUTES.TEMPLATES,
  ROUTES.TEMPLATES_RECOMMEND,
  /**
   * Invitation
   */
  ROUTES.INVITE_ACCEPT_BOARD,
  ROUTES.INVITE_ACCEPT_TEAM,
  /**
   * Board
   */
  ROUTES.BOARD_OLD,
  ROUTES.BOARD_REFERRAL,
  ROUTES.BOARD,
  ROUTES.CARD_AND_BOARD_OLD,
  ROUTES.CARD_OLD,
  ROUTES.CARD,
  ROUTES.WELCOME,
  ROUTES.CREATE_FIRST_BOARD,
  /**
   * User or Org
   */
  ROUTES.ACCOUNT,
  ROUTES.PROFILE,
  ROUTES.BILLING,
  ROUTES.BILLING_CARD,
  ROUTES.BILLING_CARD_PRODUCT,
  ROUTES.USER_OR_ORG,
  /**
   * Enterprise
   */
  ROUTES.ENTERPRISE_ADMIN,
  ROUTES.ENTERPRISE_ADMIN_TAB,
  /**
   * Member
   */
  ROUTES.MEMBER_HOME,
  ROUTES.MEMBER_HOME_BOARDS,
  ROUTES.TEAM_HIGHLIGHTS,
  ROUTES.TEAM_GETTING_STARTED,
  ROUTES.TEAM_REPORTS,
  ROUTES.MEMBER_ALL_BOARDS,
  ROUTES.MEMBER_CARDS,
  ROUTES.MEMBER_CARDS_FOR_ORG,
  ROUTES.MEMBER_ACTIVITY,
  ROUTES.MEMBER_TASKS,
  /**
   * Organization
   */
  ROUTES.ORGANIZATION_BY_ID,
  ROUTES.ORGANIZATION_GUESTS,
  ROUTES.ORGANIZATION_MEMBERS,
  ROUTES.ORGANIZATION_MEMBER_CARDS,
  ROUTES.ORGANIZATION_EXPORT,
  ROUTES.ORGANIZATION_POWERUPS,
  ROUTES.ORGANIZATION_TABLES,
  ROUTES.ORGANIZATION_FREE_TRIAL,
  /**
   * Catch all
   */
  ROUTES.ERROR_PAGE,
];
